require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = overlay;

var _color = _interopRequireDefault(require("color"));

var _reactNative = require("react-native-web/dist/index");

var _DarkTheme = _interopRequireDefault(require("./DarkTheme"));

function overlay() {
  var elevation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var surfaceColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _DarkTheme["default"].colors.surface;

  if (elevation instanceof _reactNative.Animated.Value) {
    var inputRange = [0, 1, 2, 3, 8, 24];
    return elevation.interpolate({
      inputRange: inputRange,
      outputRange: inputRange.map(function (elevation) {
        return calculateColor(surfaceColor, elevation);
      })
    });
  }

  return calculateColor(surfaceColor, elevation);
}

function calculateColor(surfaceColor, elevation) {
  var overlayTransparency;

  if (elevation >= 1 && elevation <= 24) {
    overlayTransparency = elevationOverlayTransparency[elevation];
  } else if (elevation > 24) {
    overlayTransparency = elevationOverlayTransparency[24];
  } else {
    overlayTransparency = elevationOverlayTransparency[1];
  }

  return (0, _color["default"])(surfaceColor).mix((0, _color["default"])('white'), overlayTransparency * 0.01).hex();
}

var elevationOverlayTransparency = {
  1: 5,
  2: 7,
  3: 8,
  4: 9,
  5: 10,
  6: 11,
  7: 11.5,
  8: 12,
  9: 12.5,
  10: 13,
  11: 13.5,
  12: 14,
  13: 14.25,
  14: 14.5,
  15: 14.75,
  16: 15,
  17: 15.12,
  18: 15.24,
  19: 15.36,
  20: 15.48,
  21: 15.6,
  22: 15.72,
  23: 15.84,
  24: 16
};